import React from 'react'
import PropTypes from 'prop-types'
import { FormControl, Input, FormHelperText } from '@material-ui/core'

const EmailInputs = ({ idx, usersState, handleEmailChange, style, handleRemoveEmail, handleEIChange }) => {

    const emailId = `uEmail-${idx}`
    const nameId = `uName-${idx}`
    const cpfId = `ucpf-${idx}`

    // O 1o é diferente
    if (idx === 0) {
        return <FormControl key={`Email-${idx}`}
            variant="outlined"
            className={style}>
            <Input
                type="text"
                placeholder={`Nome Completo do Primeiro Autor`}
                name={nameId}
                value={usersState[idx].uName}
                id={nameId}
                onChange={handleEIChange}
                required
                aria-describedby={nameId + "-helper"}
            />
            <FormHelperText id={nameId + "-helper"}>Nome Completo do Primeiro Autor</FormHelperText>
            <Input
                type="text"
                placeholder={`CPF do Primeiro Autor`}
                name={cpfId}
                value={usersState[idx].ucpf}
                id={cpfId}
                onChange={handleEIChange}
                required
                aria-describedby={cpfId + "-helper"}
            />
            <FormHelperText id={cpfId + "-helper"}>CPF do Primeiro Autor (sem pontos ou hífen - apenas números)</FormHelperText>

            <Input
                type="email"
                placeholder={`Email do Primeiro Autor`}
                name={emailId}
                value={usersState[idx].uEmail}
                id={emailId}
                onChange={handleEmailChange}
                required
                aria-describedby={emailId + "-helper"}
            />
            <FormHelperText id={emailId + "-helper"}>Email do Primeiro Autor</FormHelperText>
        </FormControl>
    } else {
        return <FormControl key={`Email-${idx}`}
            variant="outlined"
            className={style}
        >
            <Input
                type="text"
                placeholder={`Nome Completo do #${idx + 1} Autor`}
                name={nameId}
                value={usersState[idx].uName}
                id={nameId}
                onChange={handleEIChange}
                required
                aria-describedby={nameId + "-helper"}
            />
            <FormHelperText id={nameId + "-helper"}>Nome Completo do #{idx + 1} Autor</FormHelperText>
            <Input
                type="text"
                placeholder={`CPF do #${idx + 1} Autor`}
                name={cpfId}
                value={usersState[idx].ucpf}
                id={cpfId}
                maxLength={11}
                onChange={handleEIChange}
                required
                aria-describedby={cpfId + "-helper"}
            />
            <FormHelperText id={cpfId + "-helper"}>CPF do #{idx + 1} Autor (sem pontos ou hífen)</FormHelperText>
            <Input
                type="email"
                placeholder={`Email #${idx + 1} Autor`}
                name={emailId}
                value={usersState[idx].uEmail}
                id={emailId}
                onChange={handleEmailChange}
                required
                aria-describedby={emailId + "-helper"}
            />
            <FormHelperText id={emailId + "-helper"}>Email do #{idx + 1} Autor</FormHelperText>
            <FormHelperText id="email-helper" style={{ color: "#a11" }} onClick={() => handleRemoveEmail(idx)}>Para remover este participante, clique aqui.</FormHelperText>
        </FormControl>
    }
}

EmailInputs.propTypes = {
    idx: PropTypes.number,
    usersState: PropTypes.array,
    handleEmailChange: PropTypes.func,
}

export default EmailInputs